<template>
  <!-- The whole card opens the recipe: the title link covers the card, and
       the rating and favourite sit above it so they stay usable -->
  <v-card class="recipe-card">
    <v-skeleton-loader
      :loading="!recipe.image"
      type="image"
      :boilerplate="true"
    >
      <v-img
        :lazy-src="recipe.image"
        :src="recipe.image"
        alt=""
        :height="200"
        cover
      ></v-img>
    </v-skeleton-loader>

    <v-card-title>
      <router-link :to="recipe.id" class="recipe-link">
        {{ recipe.title }}
      </router-link>
    </v-card-title>

    <v-card-subtitle>
      <div class="above-link">
        <recipe-rating :recipe="recipe" />
      </div>
      <p v-if="recipe?.preparationTime">
        {{ recipe.preparationTime }} minutes
        <v-icon icon="mdi-clock-outline" size="small" />
      </p>
    </v-card-subtitle>

    <v-card-text>
      <p>{{ recipe.subTitle }}</p>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        class="above-link"
        :icon="favorite ? 'mdi-heart' : 'mdi-heart-outline'"
        :color="favorite ? 'primary' : undefined"
        variant="text"
        :aria-label="`Favourite ${recipe.title}`"
        :aria-pressed="favorite"
        @click="$emit('toggle-favorite')"
      />
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import { defineComponent } from 'vue';
  import RecipeRating from '@/components/recipe/recipe-rating/RecipeRating.vue';
  import type { Recipe } from '@/service/recipe/types';

  export default defineComponent({
    name: 'RecipeCard',
    components: { RecipeRating },
    props: {
      recipe: { type: Object as PropType<Recipe>, required: true },
      favorite: { type: Boolean, default: false },
    },
    emits: ['toggle-favorite'],
  });
</script>

<style scoped>
  .recipe-card {
    position: relative;
  }

  .recipe-card:hover {
    background: rgba(var(--v-theme-on-surface), var(--v-hover-opacity));
  }

  .recipe-link {
    color: inherit;
    text-decoration: none;
  }

  /* Stretches the link over the whole card */
  .recipe-link::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
  }

  .recipe-link:focus-visible {
    outline: none;
  }

  .recipe-link:focus-visible::after {
    outline: 2px solid rgb(var(--v-theme-primary));
    outline-offset: -2px;
    border-radius: inherit;
  }

  .above-link {
    position: relative;
    z-index: 2;
  }
</style>
